export const VIEW_ALL_SEGMENT_LINK = 'View All Segments';
export const MY_SEGMENTS_TOP_COUNT_RECENT = 5;
